import { z } from 'zod';

export const ResumeSchema = z.object({
  personalInfo: z.object({
    fullName: z.string().catch(''),
    email: z.string().catch(''),
    phone: z.string().catch(''),
    location: z.string().catch(''),
    linkedin: z.string().optional(),
    github: z.string().optional(),
  }),
  professionalSummary: z.string().catch(''),
  workExperience: z.array(
    z.object({
      title: z.string().catch(''),
      company: z.string().catch(''),
      location: z.string().optional(),
      startDate: z.string().catch(''),
      endDate: z.string().catch(''),
      highlights: z.array(z.string()).catch([]),
    }),
  ).catch([]),
  education: z.array(
    z.object({
      degree: z.string().catch(''),
      institution: z.string().catch(''),
      year: z.string().catch(''),
    }),
  ).catch([]),
  skills: z.object({
    technical: z.array(z.string()).catch([]),
    frameworksAndTools: z.array(z.string()).catch([]),
    managementAndDomain: z.array(z.string()).catch([]),
  }).catch({
    technical: [],
    frameworksAndTools: [],
    managementAndDomain: [],
  }),
  certifications: z.array(z.string()).optional(),
  awards: z.array(z.string()).optional(),
});

export type CanonicalResume = z.infer<typeof ResumeSchema>;

export function parseCanonicalResume(input: unknown): CanonicalResume {
  return ResumeSchema.parse(input);
}

export function safeParseCanonicalResume(input: unknown): CanonicalResume | null {
  const result = ResumeSchema.safeParse(input);
  return result.success ? result.data : null;
}
